import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Modal, ModalBody, ModalFooter,
} from 'reactstrap';
import { nsOptions } from '../i18n';

class InclusionDuplicationSuccessModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { visible: false };
  }

  show() {
    // Hide scrollbars on elements behind the success modal
    this.hiddenScrollElements = document.querySelectorAll(
      '.inclusion-form-box, .modal.fade.show',
    );
    this.savedOverflows = [];
    this.hiddenScrollElements.forEach((element, i) => {
      this.savedOverflows[i] = element.style.overflow || '';
      element.style.setProperty('overflow', 'hidden');
    });
    this.setState({ visible: true });
  }

  hide() {
    // Restore scrollbars
    if (this.hiddenScrollElements && this.savedOverflows) {
      this.hiddenScrollElements.forEach((element, i) => {
        element.style.setProperty('overflow', this.savedOverflows[i] || '');
      });
    }
    this.setState({ visible: false });
  }

  render() {
    const {
      t, newPerProjectId, onStay, onNavigate,
    } = this.props;
    const { visible } = this.state;

    return (
      <Modal
        isOpen={visible}
        centered
        size="md"
        zIndex={1060}
        modalClassName="duplication-success-modal"
        backdrop="static"
      >
        <ModalBody className="text-center pt-5 pb-0 d-flex flex-column align-items-center justify-content-center">
          <FontAwesomeIcon
            icon={['fas', 'info-circle']}
            className="mb-4"
            style={{ color: 'var(--newturquoise-2)' }}
            size="3x"
          />
          <p className="mb-0 px-3" style={{ whiteSpace: 'nowrap' }}>
            <Trans
              i18nKey="inclusion:duplicate.success-message"
              values={{ id: newPerProjectId }}
            />
          </p>
        </ModalBody>
        <ModalFooter className="justify-content-center border-0 p-0 pb-4 pt-3">
          <button
            type="button"
            className="btn btn-lg btn-outline-dark mr-2 mb-2"
            onClick={() => {
              this.hide();
              if (onStay) onStay();
            }}
          >
            {t('inclusion:duplicate.stay')}
          </button>
          <button
            type="button"
            className="btn btn-lg btn-newturquoise-2 mb-2"
            onClick={() => {
              this.hide();
              if (onNavigate) onNavigate();
            }}
          >
            {t('inclusion:duplicate.go-to-new')}
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}

InclusionDuplicationSuccessModal.propTypes = {
  t: PropTypes.func.isRequired,
  newPerProjectId: PropTypes.number,
  onStay: PropTypes.func,
  onNavigate: PropTypes.func,
};

InclusionDuplicationSuccessModal.defaultProps = {
  newPerProjectId: null,
  onStay: null,
  onNavigate: null,
};

export default withTranslation(nsOptions.ns, nsOptions)(InclusionDuplicationSuccessModal);
